// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1no92","modalForm":"UpgradeEpcsModal_modalForm__VOYOH","modalFooter":"UpgradeEpcsModal_modalFooter__3LZSn"};